/** @format */

import React from 'react';
import styled from 'styled-components';

interface NotificationBadgeProps {
  notificationCount: number;
}

const StyledNotificationBadge = styled.span`
  position: absolute;
  top: 0%;
  right: -20%;
  height: 17px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--error-500);
  color: var(--error-100);
  font-size: var(--font-xs);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--error-200);
`;

function NotificationBadge(props: NotificationBadgeProps) {
  return <StyledNotificationBadge>{props.notificationCount < 100 ? props.notificationCount : '99+'}</StyledNotificationBadge>;
}

export default NotificationBadge;
